import { instance } from '@/utils/http.js'

// 根据id搜索题目
export const getTopic = function (params) {
  return instance({
    url: '/api/v1/public/find_question',
    method: 'get',
    params
  })
}